export class TIME_DEBOUCE {
  static SEARCH_HEADER = 1000;
}

export class ROLE {
  static ROLE_ADMIN = "ROLE_ADMIN";
  static ROLE_USER = "ROLE_USER";
  static ROLE_STAFF = "ROLE_INVERTOR";
}

export class EFRAME_SIZE {
  static FRAME_4B2 = "4B2";
  static FRAME_B4 = "B4";
  static FRAME_Upload = "Upload";
  static FRAME_4 = "4";
}
